import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

export const getCredentialStatus = (credential) => {
	if (!credential) return { text: 'Active', color: 'green' };

	const { startDate, endDate } = credential;

	// No dates = permanent = Active
	if (!startDate || !endDate) return { text: 'Active', color: 'green' };

	const start = dayjs(startDate);
	const end = dayjs(endDate);

	// 🔥 Inner Range Lifesaver: If it's year 1 (0001), it's Permanent = Active
	if (start.year() === 1 && end.year() === 1) return { text: 'Active', color: 'green' };

	const now = dayjs();

	// 1. Is it currently within the time period? -> Active
	if (now.isBetween(start, end, null, '[]')) return { text: 'Active', color: 'green' };

	// 2. Has the current time passed the end date? -> Expired
	if (now.isAfter(end)) return { text: 'Expired', color: 'red' };

	// 3. Start date is in the future -> Inactive
	return { text: 'Inactive', color: 'orange' };
};
